import { MutationTree } from 'vuex'
import State from './types'

export const mutations: MutationTree<State> = {
  error(state) {
    state.Error = true
  },
  success(state) {
    state.Error = false
  },
  setCatalogId(state, { catalogId } : { catalogId?: number }) {
    state.CatalogId = catalogId
  },
}
